import { MutationTree } from 'vuex';
import { HistoryState } from '../../models';
import { RemoveQueryHistoryMutation } from './mutations/remove-query-history.mutation';
import { SetClickedResultHistoryMutation } from './mutations/set-clicked-result-history.mutation';
import { SetEnabledQueryHistoryMutation } from './mutations/set-enabled-query-history.mutation';
import { SetQueryHistoryMutation } from './mutations/set-query-history.mutation';
import { SetSessionQueryHistoryMutation } from './mutations/set-session-query-history.mutation';

export const HISTORY_MUTATIONS: MutationTree<HistoryState> = {
  ...new RemoveQueryHistoryMutation().mutations,
  ...new SetEnabledQueryHistoryMutation().mutations,
  ...new SetQueryHistoryMutation().mutations,
  ...new SetClickedResultHistoryMutation().mutations,
  ...new SetSessionQueryHistoryMutation().mutations
};
